<template>
  <div class="reference-card-list-skeleton-loader pb-4">
    <reference-card-skeleton-loader v-for="i in 3" :key="i" />
  </div>
</template>

<script>
import ReferenceCardSkeletonLoader from './ReferenceCardSkeletonLoader';

export default {
  name: 'ReferenceCardListSkeletonLoader',
  components: {
    ReferenceCardSkeletonLoader,
  },
};
</script>

<style lang="scss" scoped>
.reference-card-list-skeleton-loader {
  display: grid;
  gap: 12px;
}
</style>
